module.exports = __webpack_public_path__ + "img/icon-coach-grey.a54da4b5.svg";